import { Component, inject, InjectionToken } from '@angular/core';
import { OrdersRow } from '../../..';
import { SalesOrderTableCustomComponentDirective } from './sales-order-table-custom.component';

export const SALESPERSON_LINK = new InjectionToken<(orderId: OrdersRow) => string>(
  'SALES_ORDERS_TABLE_SALESPERSON_LINK',
  {
    providedIn: 'root',
    factory: () => () => '/st/edit/',
  },
);

export const SALESPERSON_LINK_QUERY = new InjectionToken<(orderId: OrdersRow) => Record<string, string>>(
  'SALES_ORDERS_TABLE_SALESPERSON_LINK_QUERY',
  {
    providedIn: 'root',
    factory: () => (order: OrdersRow) => ({ sales_person_id: order.salespersonId }),
  },
);

@Component({
  selector: 'sales-ui-salesperson-cell',
  template: `
    <ng-container>
      <div class="title">
        <a [routerLink]="salespersonLink(element)" [queryParams]="salespersonLinkQuery(element)">
          {{ getSalespersonName() }}
        </a>
      </div>
      <div class="subtitle">{{ getSalespersonEmail() }}</div>
    </ng-container>
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        min-width: 0;
        max-width: 100%;
      }

      .title {
        font-size: 14px;
        font-weight: 500;
      }

      .subtitle {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.54);
      }
    `,
  ],
})
export class SalespersonCellComponent extends SalesOrderTableCustomComponentDirective {
  salespersonLink = inject(SALESPERSON_LINK);
  salespersonLinkQuery = inject(SALESPERSON_LINK_QUERY);

  getSalespersonName(): string {
    if (!!this.element.salesperson?.firstName || !!this.element.salesperson?.lastName) {
      return this.element.salesperson?.firstName + ' ' + this.element.salesperson?.lastName;
    }
    return '';
  }

  getSalespersonEmail(): string {
    return this.element.salesperson?.email;
  }
}
